const hiddeHeaderSection = () => {
    const resultsContainer = document.querySelector('[data-search-results-content]');
    const isNoResultSectionVisible = !!document.querySelector('[data-no-result="true"]');
    const hiddenSections = document.querySelectorAll('[data-hidden-section]');

    if (!isNoResultSectionVisible) {
        hiddenSections.forEach(element => element.removeAttribute('hidden'));
        resultsContainer.classList.remove('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
        return;
    }

    hiddenSections.forEach(element => element.setAttribute('hidden', ''));
    resultsContainer.classList.add('nhs-c-wrapper--no-results', 'nhs-mq-wrapper--no-results-medium');
};

export default hiddeHeaderSection;